import { skipToken } from '@apollo/client';

import {
  TiptapTokenFragment,
  getError,
  getTypeOrNull,
  useGetTiptapTokenSuspenseQuery,
} from '@spotify/confidence-graphql';

export const useTiptapTokenSuspense = ({
  name,
  skip = false,
}: {
  name: string;
  skip?: boolean;
}) => {
  const { data, error: networkError } = useGetTiptapTokenSuspenseQuery(
    skip ? skipToken : { variables: { name } },
  );

  const getTiptapToken = getTypeOrNull(data?.getTiptapToken) ?? undefined;
  const appError = getError(data?.getTiptapToken) ?? undefined;
  const error = appError ?? networkError;

  if (error) {
    throw error;
  }

  return {
    getTiptapToken: getTiptapToken as TiptapTokenFragment | undefined,
  };
};
